export default "__VITE_ASSET__CeLvOTFO__"